module.exports = __webpack_public_path__ + "static/media/publish-videos-images-tablet-es.e0a1f022.png";